export default {
  de: {
    titles: {
      start_page: 'Startseite',
      login: 'Einloggen',
      register: 'Registrieren',
      profile: 'Profil',
      logout: 'Ausloggen',
      impressum: 'Impressum',
      forgot_password: 'Passwort vergessen',
      reset: 'Passwort zurücksetzen',
      email_verification: 'E-Mail-Verifizierung',
      update_password: 'Ändere das Passwort',
      update_profile: 'Profil aktualisieren',
      report_a_problem: 'Ein Problem melden',
      datenschutz: 'Datenschutz',
      create_car: 'Erstelle ein neues Auto',
      edit_car: 'Auto bearbeiten',
      cars: 'Autos',
      car_type: 'Autotypen',
      sva_export: 'SVA-Export',
      entities: 'Entitäten',
      export_service_times: 'Servicezeiten exportieren',
      export_multi_expenses_car_uses: 'Export selected car-uses',
      export_multi_reports: 'Export selected reports',
      locked: 'Gesperrt',
      car_times: 'Car times',
      new_car: 'New car',
      new_service_time: 'New service time',
      new_expense: 'New expense',
      new_scheduled_service_time: 'New scheduled service time',
      version_history: 'Versionsverlauf',
      current_version: 'Aktuelle Version',
      current_page: 'Aktuelle Seite',
      changes_detected: 'Erkannte Änderungen',
      downloads: 'Downloads',
      create_download: 'Download erstellen',
      edit_download: 'Download bearbeiten',
      download_categories: 'Download-Kategorien',
      create_download_category: 'Kategorie erstellen',
      edit_download_category: 'Kategorie bearbeiten',
      remark_preview: 'Bemerkung',
    },
    fields: {
      name: 'Name',
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'Email',
      password: 'Passwort',
      password_confirmation: 'Passwort Bestätigung',
      repeat_password: 'Passwort wiederholen',
      current_password: 'Derzeitiges Passwort',
      new_password: 'Neues Kennwort',
      new_password_repeat: 'Bestätige neues Passwort',
      gender: 'Geschlecht',
      dob: 'Geburtsdatum',
      licenses: 'Lizenzen',
      street: 'Straße',
      postal_code: 'Postleitzahl',
      town: 'Stadt',
      country: 'Land',
      nationality: 'Staatsangehörigkeit',
      bank_name: 'Bank Name',
      iban: 'IBAN',
      bic: 'BIC',
      sex: {
        1: 'Herr',
        2: 'Frau',
        3: 'Divers',
      },
      verified: 'Verifiziert',
      completed: 'Fertiggestellt',
      license_plate: 'Nummernschild',
      car_type: 'Auto typ',
      owner: 'Inhaber',
      zub: 'ZUB',
      sva_print: 'SVA drucken',
      admin_drafts_also: 'Meine Entwürfe einbeziehen',
      all_drafts_also: 'Entwürfe einbeziehen',
      completed_and_draft: 'Fertiggestellt & Entwurf',
      draft_only: 'Entwurf',
      none_drafts: 'Ohne Zugluft',
      status: 'Status',
      export_expenses: 'Exportkosten',
      show_deleted_records: 'Show deleted records',
      username: 'Nutzername',
      export_select: 'Select to download multiple expenses reports',
      invoice_select: 'Select to update invoice number',
      multi_report_export_select: 'Select to download multiple reports',
      sum_service_times_select: 'Wählen Sie aus, um Servicezeiten zu summieren',
      invoicing_details: 'Rechnungsdetails',
      version: 'Version',
      notes: 'Notizen',
      created_at: 'Erstellt am',
      current: 'Aktuell',
      field: 'Feld',
      previous_value: 'Vorheriger Wert',
      current_value: 'Aktueller Wert',
      updated_by: 'Aktualisiert von',
      add_report: 'Bericht hinzufügen',
      category: 'Kategorie',
      attachment: 'Anhang',
      google_maps: 'Google Maps Link',
      location: 'Ort',
      show_remark: 'Bemerkung anzeigen',
      show_google_link: 'Google Maps Link anzeigen',
      including_zub: 'Inklusive ZUB',
    },
    table_labels: {
      completed: 'Fertiggestellt',
      license_plate: 'Nummernschild',
      car_type: 'Auto typ',
      owner: 'Inhaber',
      zub: 'ZUB',
      verified: 'Verifiziert',
      sva_print: 'SVA drucken',
      mobile_number: 'Handynummer',
      attachment: 'Anhang',
    },
    placeholders: {
      name: 'Name eingeben',
      first_name: 'Vorname eingeben',
      last_name: 'Nachname eingeben',
      email: 'Email eingeben',
      password: 'Passwort eingeben',
      password_confirmation: 'Passwort Bestätigung eingeben',
      current_password: 'Aktuelles Passwort eingeben',
      new_password_repeat: 'Passwortbestätigung eingeben',
      description: 'Beschreibung eingeben',
      comment: 'Kommentar eingeben',
      date: 'Datum auswählen',
      licenses: 'Lizenzen eingeben',
      street: 'Straße eingeben',
      postal_code: 'Postleitzahl eingeben',
      town: 'Stadt eingeben',
      country: 'Land eingeben',
      nationality: 'Staatsangehörigkeit eingeben',
      bank_name: 'Bank Name eingeben',
      iban: 'IBAN eingeben',
      bic: 'BIC eingeben',
      date_interval_start: 'Start des Datumsintervalls',
      date_interval_end: 'Datumsintervallende',
      license_plate: 'Bitte geben Sie das Kennzeichen im Format „DO KK 123" ein.',
      car_type: 'Auto typ',
      owner: 'Inhaber',
      areas_dropdown: 'Bereich aus Liste auswählen',
      username: 'Nutzername',
      total_service_time: 'Gesamte Servicezeit',
    },
    actions: {
      list: 'Liste',
      continue: 'Weiter',
      forgot_password: 'Passwort vergessen?',
      register_now: 'Jetzt neu registrieren',
      send_forgot_password: 'Neues Passwort anfordern',
      submit: 'Speichern',
      ok: 'OK',
      stop: 'Abbrechen',
      dismiss: 'Verwerfen',
      dismissed: 'Verworfen',
      changes: 'Änderungen',
      new_version: 'Neue Version',
      view: 'Ansehen',
      view_current_version: 'Zur aktuellen Version',
      sum: 'Summieren',
    },
    messages: {
      leave_pending: 'Offener Urlaubsantrag',
      leave_confirmed: 'Bestätigter Urlaubsantrag',
      forgot_password_sent: 'Der Wiederherstellungslink wurde an Ihre E-Mail-Adresse gesendet',
      password_changed: 'Das Passwort wurde zurückgesetzt. Sie können sich jetzt einloggen.',
      empty_list: 'Die Liste ist leer.',
      select_category_first: 'Bitte wählen Sie zuerst eine Kategorie aus.',
      multiselect_enter: 'Geben Sie mindestens 2 Buchstaben ein.',
      export_in_progress: 'Der Export wird erstellt, das kann etwas dauern. Bitte warten...',
      please_send: 'Bitte senden Sie alle Originalbelege klar beschriftet mit der Expense-ID (rot / z.B. #149) an:',
      own_interest: 'In eurem eigenen Interesse bitten wir euch, eine Kopie der Belege zu machen bevor ihr sie verschickt.',
      before_address:
        'Nach Abschluss des Reports die Auslagenabrechnung herunterladen, und per Email an folgende Adresse senden: expenses@kks-hahn.de',
      complete_warning:
        'Bitte füllen Sie alle roten Felder aus, um einen Report im Status „Draft" (als Entwurf) zu speichern. Um einen Report als „Completed" zu speichern, müssen zusätzlich auch die grünen Felder gefüllt sein.',
      no_changes_detected: 'Keine Änderungen erkannt',
      viewing_old_version: 'Sie sehen eine ältere Version',
      loading_comparison: 'Lade Vergleich...',
      version_created: 'Neue Version erstellt',
    },
    errors: {
      terms: 'Sie müssen die Datenschutzrichtlinien akzeptieren, um die Registrierung fortzusetzen.',
      service_end_after_service_start: 'Service End must be after Service Start',
    },
    infos: {
      licenses: 'Beschreiben Sie Ihren Führerschein und andere Lizenzen für die Beförderung von Passagieren usw.',
      bic: 'Nur bei Konten außerhalb Deutschlands notwendig',
      meeting_point: 'Ort an dem der Einsatz beginnt',
      meeting_date: 'Start-Zeitpunkt des Einsatzes',
      meeting_notes: 'Kurze Schliderung des Auftrages, z.B.: 8:00 Uhr FH-Pickup, Fahrt ins Hotel, etc., sowie kurze Erklärung der diversen Kosten',
      vip_description: 'Es muss das Feld „VIP" ODER das Feld "VIP description" ausgefüllt sein, um den Bericht zu speichern.',
      status: 'Draft = Bearbeitungsmodus / ' + 'Completed = Bearbeitung abgeschlossen',
      licence_plate: 'Kennzeichen',
      car_type: 'Fahrzeugtyp',
      car_owner: 'Fahrzeughalter',
      car_use: 'Verwendetes Fahrzeug',
      date: 'Auftragsdatum',
      zub: 'Bitte hier ein Foto der ersten Seite des Fahrzeugscheins hochladen.',
      takeover_from: 'Person oder Firma, die dir das Fahrzeug übergeben hat.',
      return_to: 'Person oder Firma, an die das Fahrzeug übergeben wurde.',
      takeover_date: 'Zeitpunkt der Fahrzeugübernahme',
      return_date: 'Zeitpunkt der Fahrzeugrückgabe',
      km_status_takeover: 'Kilometerstand Fahrzeugübernahme',
      km_status_return: 'Kilometerstand Fahrzeugrückgabe. Bitte bei Langzeitmieten und Transportern eintragen.',
      approach_start: 'Beginn der Anfahrt',
      approach_end: 'Ende der Anfahrt',
      service_start: 'Beginn des Fahrdienst',
      service_end: 'Ende des Fahrdienst',
      return_start: 'Beginn der Abfahrt',
      return_end: 'Ende der Abfahrt',
      note: 'Kurze Schliderung des Auftrages, z.B.: 8:00 Uhr FH-Pickup, Fahrt ins Hotel, etc., sowie kurze Erklärung der diversen Kosten',
      cost_type: 'Auswahl der Kostenart. Bitte beachtet den Steuersatz und ob die Kosten in Deutschland oder im Ausland angefallen sind.',
      expense_date: 'Datum an dem die Kosten angefallen sind',
      amount: 'Betrag in Euro',
      amount_description: 'Kurze Erklärung der Kosten',
      export_expenses: 'Wenn diese Option deaktiviert ist, steht der Export von Ausgaben für diesen Bericht nicht zur Verfügung.',
      loading_notifications: 'Lade Benachrichtigungen...',
      empty_notifications: 'Keine Benachrichtigungen',
      showing_results: 'Zeige {start} bis {end} von {total} Ergebnissen an.',
      job_location: 'Ort des Auftrags',
    },
    search: {
      message: 'Die Suche funktioniert nach {entity}.',
      entities: {
        description: 'der Beschreibung',
        article_name: 'dem Bezeichnung',
        firm_name: 'dem Firmenname',
        name: 'dem Name',
      },
      drafts: 'Drafts',
      lock_status: {
        label: 'Lock status',
        locked: 'Locked',
        unlocked: 'Unlocked',
        all: 'Locked & unlocked',
      },
    },
      alerts: {},
    copyright: '© 2019 KKS',
    name: 'KKS',
    tos: 'Datenschutzrichtlinien',
    term: 'Ich akzeptiere die {0} von Potpourri',
  },
};
